module.exports = __webpack_public_path__ + "static/img/sl.7fac599c.svg";